import { Component, OnInit, OnDestroy, HostListener } from "@angular/core";
import { TranslationService } from "./core/services/translation/translation.service";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { UserIdleService } from "angular-user-idle";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Spinkit } from "ng-http-loader";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { CrossTabIdleSyncService } from "./core/services/crossTabIdleSync.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  ispopup: boolean;
  counter: any;
  isConnected = false;
  hasNetworkConnection: boolean = false;
  hasInternetAccess: boolean = false;
  noInternetConnection: boolean = false;

  networkStatus: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;

  public spinkit = Spinkit;
  public filteredUrlPatterns: string[] = ['/assets/', '/rest/ping'];

  showSettings = false;
  currentTheme = "blue";
  primaryColor = "#1a237e";

  constructor(
    private translationService: TranslationService,
    private router: Router,
    private userIdle: UserIdleService,
    private dialog: MatDialog,
    private toastrService: ToastrService,
    private idleSyncService: CrossTabIdleSyncService
  ) {
    this.translationService.setAppLangOnStartup();
    this.ispopup = false;
  }

  toggleSettingsPanel(): void {
    this.showSettings = !this.showSettings;
  }

  selectTheme(theme: string): void {
    this.currentTheme = theme;
    localStorage.setItem("gev-theme", theme);
    this.applyTheme(theme);
  }

  selectPrimaryColor(color: string): void {
    this.primaryColor = color;
    localStorage.setItem("gev-primary-color", color);
    this.applyPrimaryColor(color);
  }

  private applyTheme(theme: string): void {
    const body = document.body;
    body.classList.remove("theme-blue", "theme-dark", "theme-light");
    body.classList.add(`theme-${theme}`);
  }

  private applyPrimaryColor(color: string): void {
    document.documentElement.style.setProperty("--primary-color", color);
    const hex = color.replace("#", "");
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    if (!isNaN(r) && !isNaN(g) && !isNaN(b)) {
      document.documentElement.style.setProperty("--primary-color-rgb", `${r}, ${g}, ${b}`);
      document.documentElement.style.setProperty("--primary-color-muted", `rgba(${r}, ${g}, ${b}, 0.8)`);
      document.documentElement.style.setProperty("--primary-gradient", `linear-gradient(135deg, ${color} 0%, rgba(${r}, ${g}, ${b}, 0.7) 100%)`);
    } else {
      document.documentElement.style.setProperty("--primary-color-rgb", "26, 35, 126");
      document.documentElement.style.setProperty("--primary-color-muted", "rgba(26, 35, 126, 0.8)");
      document.documentElement.style.setProperty("--primary-gradient", `linear-gradient(135deg, ${color} 0%, rgba(26, 35, 126, 0.7) 100%)`);
    }
  }

  @HostListener("document:mousemove")
  @HostListener("document:keydown")
  resetIdleTimer() {
    this.idleSyncService.updateLastActivity();
  }

  ngOnInit(): void {
    // Load visual settings from cache
    this.currentTheme = localStorage.getItem("gev-theme") || "light";
    this.primaryColor = localStorage.getItem("gev-primary-color") || "#0288d1";
    this.applyTheme(this.currentTheme);
    this.applyPrimaryColor(this.primaryColor);

    const route = this.router.url;
    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("token") === undefined
    ) {
      this.router.navigate(["/login"]);
    }
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.translationService.setAppLangOnStartup();
    //Start watching for user inactivity.
    if (localStorage.getItem("token") != null && route != "/login") {
      this.userIdle.startWatching();
    }

  }

  ngOnDestroy(): void {
    this.networkStatus$.unsubscribe();
  }

  stop(): any {
    this.userIdle.stopTimer();
  }

  stopWatching(): any {
    this.userIdle.stopWatching();
  }

  startWatching(): any {
    this.userIdle.startWatching();
  }

  restart(): any {
    this.userIdle.resetTimer();
  }

  confirmBox(): any {
    Swal.fire({
      title: "Are you sure want to remove?",

      text: "You will not be able to recover this file!",

      icon: "warning",

      showCancelButton: true,

      confirmButtonText: "Yes, delete it!",

      cancelButtonText: "No, keep it",
    }).then((result: any) => {
      if (result.value) {
        Swal.fire(
          "Deleted!",

          "Your imaginary file has been deleted.",

          "success"
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelled",

          "Your imaginary file is safe :)",

          "error"
        );
      }
    });
  }

  confirm2(): any {
    let timerInterval: any;
    Swal.fire({
      title: "Auto close alert!",
      html: "I will close in <b></b> milliseconds.",
      timer: 2000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
      }
    });
  }




  reloadComponent(): any {
    // const currentUrl = this.router.url;
    const currentUrl = "login";
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate([currentUrl]);
  }
}